import { useContext } from 'react';
import AppContext from '../components/App/AppContext';
import { setStorageUser } from '../helpers/Auth';

const useSetUser = () => {
  const { setUser } = useContext(AppContext);

  // eslint-disable-next-line consistent-return
  return rawUser => {
    if (rawUser === null) return false;
    const user = typeof rawUser === 'string' ? JSON.parse(rawUser) : rawUser;
    const storageUser = setStorageUser(user);
    setUser(storageUser);
  };
};

export default useSetUser;
